<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.atividadeColetiva"
        ref="DataTable"
        sort-by="dataCadastro"
    >

        <template v-slot:cell(dataCadastro)="row">
            {{ row.value | formatDate }}
        </template>

        <template v-slot:cell(dataExportacao)="{ item }">

            <span v-if="item.dataExportacao">
                {{ item.dataExportacao }} às {{ item.horarioExportacao }} - {{ item.profissionalExportacao }}
            </span>
            <span v-else>-</span>
        </template>

        <template v-slot:cell(actions)="{ item }">

            <rkm-button
                authorize="store-atencao-basica-atividade-coletiva"
                color="success"
                small
                title="Duplicar"
                @click.stop="duplicar(item)"
            >
                <rkm-icon icon="clone" />
            </rkm-button>

            <rkm-button
                v-if="verificarPermissao('show-atencao-basica-atividade-coletiva')"
                color="info"
                small
                title="Exportar para XLS"
                @click.stop="exportar(item)"
            >
                <rkm-icon icon="file-export" />
            </rkm-button>

            <rkm-button
                color="primary"
                small
                title="Editar"
                @click.stop="$router.push({ name: 'atencao-basica-atividade-coletiva-edit', params: { id: item.id } })"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="!item.exportacaoId && !item.procedimentoExportado"
                authorize="destroy-atencao-basica-atividade-coletiva"
                color="danger"
                small
                title="Excluir"
                @click.stop="handleDestroy(item)"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>

// Filters.
import formats from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

import { repository, error, object, data, file, permissao, stringCase, mask, unmask } from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'dataCadastro',
                    label: 'Data',
                    name: 'atividadeColetiva.dataCadastro',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'profissionalResponsavel',
                    label: 'Responsável',
                    name: 'profissionalResponsavel',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'localAtividade',
                    label: 'Local',
                    name: 'localAtividade',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'atividadeTipo',
                    label: 'Atividade',
                    name: 'atividadeTipo.descricao',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-4',
                    key: 'saudeTemas',
                    label: 'Tema',
                    name: 'saudeTemas',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'totalParticipantes',
                    label: 'Participantes',
                    name: 'atividadeColetiva.totalParticipantes',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataExportacao',
                    label: 'Exportação',
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                }
            ];
        },
    },
    filters: {
        formatDate: formats.formatDate,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        duplicar(item) {

            const duplicar = async () => this.$router.push({
                name: 'atencao-basica-atividade-coletiva-duplicar',
                params: { id: item.id }
            })

            this.showConfirmation(
                'Os dados desta ficha serão copiados para uma nova atividade coletiva. Deseja continuar?',
                duplicar
            )
        },
        exportar(item) {

            this.setLoading()

            this.repositories.exportacao.atividadeColetiva(item.id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy({ id }) {

            const destroy = async () => {

                this.setLoading()

                this.repositories.atividadeColetiva.destroy(id)
                    .then(() => {
                        this.showSaveNotification('Registro excluído com sucesso!')
                        this.$refs.DataTable.refresh()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            this.showDeleteConfirmation(null, destroy)
        },
    },
    created() {

        this.repositories = {
            atividadeColetiva: this.getConectaSusRepository('atencaoBasica.atividadeColetiva'),
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
        };
    },
    mixins: [repository, error, object, data, file, permissao, stringCase, mask, unmask],
}
</script>